import { Button, CircularProgress, styled } from "@material-ui/core";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import {
  EPOCUS_PRIMARY,
  EPOCUS_STATUS_REVIEWED_TEXT,
  rem,
} from "../epocus-palette";
import type { HydratedExamImage } from "../hooks/use-epocus-exam-images";
import { useOfflineCine } from "./use-offline-cine";

const ActionButton = styled(Button)({
  alignSelf: "flex-start",
  marginRight: "auto",
  minHeight: 44,
  padding: "0 8px",
  fontSize: rem(13),
  textTransform: "none",
  color: EPOCUS_PRIMARY,
});

export const OfflineCineButton: FC<{ images: HydratedExamImage[] }> = ({
  images,
}) => {
  const { playableCount, state, storedCount, makeAvailableOffline } =
    useOfflineCine(images);

  if (playableCount === 0) return null;

  if (state === "STORED") {
    return (
      <ActionButton
        disabled
        startIcon={<CloudDoneIcon fontSize="small" />}
        style={{ color: EPOCUS_STATUS_REVIEWED_TEXT }}
      >
        {playableCount === 1
          ? "Loop available offline"
          : `${playableCount} loops available offline`}
      </ActionButton>
    );
  }

  if (state === "STORING") {
    return (
      <ActionButton
        disabled
        startIcon={
          <CircularProgress size={14} style={{ color: EPOCUS_PRIMARY }} />
        }
      >
        Saving for offline… {storedCount}/{playableCount}
      </ActionButton>
    );
  }

  return (
    <ActionButton
      startIcon={<CloudDownloadIcon fontSize="small" />}
      onClick={makeAvailableOffline}
    >
      {state === "FAILED"
        ? "Couldn't save for offline — retry"
        : "Make available offline"}
    </ActionButton>
  );
};
